























































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class ReferenceDateFilter extends Vue {
  id = "refdate-filter-popover";
  target = "refdate-filter-target";
  filter = this.defaultFilter();
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_REFDATE_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { referenceDate } = this.$store.state.gaps.filter;
    this.filter = JSON.parse(JSON.stringify(referenceDate));
  }
}
